// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"14a77ab2","703":"05963170"}[chunkId] + ".chunk.js";
};